<template>
  <div class="shop-fix">
    <snow></snow>
  </div>
</template>
<script>
import '@zg/snow/index.css'
import { registerSnow } from '@zg/snow'
import { getWebToken, getUserId, defaultParams } from '@/common/utils/common'

const routerParams = window.location.href.split('/createdTemp/')[1]
const platform = routerParams.split('/')[0]
const shopId = routerParams.split('/')[1]
const parentTplId = routerParams.split('/')[2]
const tplId = routerParams.split('/')[3]
console.log({
  projectType: 'seller',
  scene: 'shop',
  platform,
  _wtk: getWebToken(),
  _uid: getUserId(),
  _aid: defaultParams.aid.business_pc,
  tplId: tplId,
  parentTplId,
  shopId
})
export default {
  name: 'shopFix',
  data() {
    return {}
  },
  components: {
    Snow: registerSnow({
      projectType: 'seller',
      scene: 'shop',
      platform,
      _wtk: getWebToken(),
      _uid: getUserId(),
      _aid: defaultParams.aid.business_pc,
      tplId: tplId,
      parentTplId,
      shopId
    })
  },
  methods: {},
  created() {}
}
</script>

<style lang="stylus" scoped></style>
